import { createVNode as a, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NoFilledStandard.js";
import i from "../components/PfIcon.js";
const r = (t, o) => {
  const e = {
    ...t,
    ...o.attrs
  };
  return a(i, d(e, {
    icon: l
  }), null);
};
r.displayName = "NoFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
